(ns manatee.admin.task-config.subs
  (:require [manatee.admin.task-config.app-db :as app-db]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::task-config-id
 (fn task-config-id
   [db _]
   (app-db/get-task-config-id db)))

(rf/reg-sub
 ::selected-task
 (fn selected-task
   [db _]
   (app-db/get-selected-task db)))

(rf/reg-sub
 ::task-config
 (fn task-config
   [db [_ id]]
   (app-db/get-task-config db id)))

(rf/reg-sub
 ::task-configs
 (fn task-configs
   [db _]
   (app-db/get-task-configs db false)))

(rf/reg-sub
 ::task-config-names
 (fn task-config-names
   [db _]
   (app-db/get-task-config-names db)))

(rf/reg-sub
 ::active-task-configs
 (fn active-task-configs
   [db _]
   (app-db/get-task-configs db true)))

(rf/reg-sub
 ::task-configs-map
 (fn task-configs-map
   [db _]
   (app-db/get-task-config-map db)))
